// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26F42","name":"Header_name__3MWov","birthday":"Header_birthday__2l2Yp","skeleton":"Header_skeleton__3w9VO"};